import { LayoutDashboard, ClipboardList, ClipboardCheck, Megaphone,GraduationCap, Users, BriefcaseBusiness, School, WalletCards, ListTodo, MessageSquareText, HeartHandshake, Files, ChartNoAxesCombined, Settings, Backpack } from 'lucide-react';
import { PERMISSIONS } from '../../core/permissions/roles';

export const navigation = [
  { to: '/dashboard', label: 'Tableau de bord', icon: LayoutDashboard, permission: PERMISSIONS.DASHBOARD_VIEW },
  { to: '/inscriptions', label: 'Inscriptions', icon: ClipboardList, permission: PERMISSIONS.REGISTRATIONS_VIEW },
  { to: '/eleves', label: 'Élèves', icon: GraduationCap, permission: PERMISSIONS.STUDENTS_VIEW },
  { to: '/parents', label: 'Parents', icon: Users, permission: PERMISSIONS.PARENTS_VIEW },
  { to: '/personnel', label: 'Personnel', icon: BriefcaseBusiness, permission: PERMISSIONS.EMPLOYEES_VIEW },
  {
  to: '/travaux-validation',
  label: 'Travaux à valider',
  icon: ClipboardCheck,
  permission: PERMISSIONS.HOMEWORK_VALIDATE
},
  { to: '/classes', label: 'Classes', icon: School, permission: PERMISSIONS.CLASSES_VIEW },
  { to: '/fournitures-scolaires', label: 'Fournitures scolaires', icon: Backpack, permission: PERMISSIONS.SCHOOL_SUPPLIES_MANAGE },
  { to: '/finance', label: 'Finance & caisse', icon: WalletCards, any: [PERMISSIONS.FINANCE_STUDENT_LOOKUP, PERMISSIONS.FINANCE_GLOBAL_VIEW, PERMISSIONS.CASH_OWN_VIEW] },
  { to: '/taches', label: 'Tâches', icon: ListTodo, permission: PERMISSIONS.TASKS_VIEW },
  { to: '/communication', label: 'Communication', icon: MessageSquareText, permission: PERMISSIONS.COMMUNICATION_VIEW },
  {
  to: '/annonces',
  label: 'Annonces générales',
  icon: Megaphone,
  permission: PERMISSIONS.COMMUNICATION_VIEW
},
  { to: '/rh', label: 'Ressources humaines', icon: HeartHandshake, permission: PERMISSIONS.HR_VIEW },
  { to: '/documents', label: 'Documents', icon: Files, permission: PERMISSIONS.DOCUMENTS_VIEW },
  { to: '/rapports', label: 'Rapports', icon: ChartNoAxesCombined, permission: PERMISSIONS.REPORTS_VIEW },
  { to: '/parametres', label: 'Paramètres', icon: Settings, permission: PERMISSIONS.SETTINGS_MANAGE }
];
